const TranslationService = function() {

    var translations = {};
    var callbacks = new Map();
    var currentContext;

    function setTranslations(context, strings) {
        //console.log("context:",context+" strings:",strings);
        currentContext = context;
        translations[context] = strings;

        if (callbacks.size > 0) {
            callbacks.forEach((value,key) => {
                if(key == context)
                    value(tanslations[context]);
            })
        }
    }

    function getTranslations(context, callback) {
        if (callback) {
            callbacks.set(context, callback);
        }
        return translations[context];
    }

    function getCurrentContext() {
        return currentContext;
    }

    function setCurrentContext(context) {
        currentContext = context;
    }

    return {
        setTranslations: setTranslations,
        getTranslations: getTranslations,
        setCurrentContext: setCurrentContext,
        getCurrentContext: getCurrentContext
    }
};

export default TranslationService;


//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/translationService.js
// module id = 334
// module chunks = 0